import React from 'react'
import { Dialog, DialogContent, DialogActions, Typography, makeStyles, InputLabel, Select, MenuItem, FormControl } from '@material-ui/core'
import Controls from "../controls/Controls";
import { red } from '@material-ui/core/colors';

const useStyles = makeStyles(theme => ({
    dialog: {
        padding: theme.spacing(2),
    },
    dialogTitle: {
        textAlign: 'center',
        textTransform: 'uppercase',
        color: red[600]
    },
    dialogContent: {
        textAlign: 'center'
    },
    dialogAction: {
        justifyContent: 'center'
    },
    titleIcon: {
        backgroundColor: theme.palette.secondary.light,
        color: theme.palette.secondary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.light,
            cursor: 'default'
        },
        '& .MuiSvgIcon-root': {
            fontSize: '8rem',
        }
    },
    formFieldContainer: {
        display: 'flex',
        width: '46%',
        marginRight: '1rem',
        marginLeft: '1rem',
        marginBottom: 8,
        marginTop: 8
    },
    inputLabel: {
        marginLeft: '1rem',
        marginRight: '1rem',
        width: '8rem',
        fontSize: 14,
        zIndex: 1000,
        lineHeight: 1.75,
        textTransform: 'uppercase',
        fontWeight: 'bold',
        display: 'flex',
        alignItems: 'center'
    },
}))

export default function ConfirmChoiceDialog(props) {

    const { confirmDialog, setConfirmDialog } = props;
    const classes = useStyles()

    return (
        <Dialog open={confirmDialog.isOpen} classes={{ paper: classes.dialog }}>
            <DialogContent className={classes.dialogContent}>
                <Typography variant="h5" className={classes.dialogTitle}>
                    {confirmDialog.title}
                </Typography>
                <Typography variant="subtitle2">
                    {confirmDialog.subTitle}
                </Typography>
                <Typography variant="subtitle2">
                    <FormControl className={classes.formFieldContainer} style={{ minWidth: '350px' }} fullWidth>
                        <InputLabel id="choice-confirm" className={classes.inputLabel}>
                            {confirmDialog.choiceTitle}
                        </InputLabel>
                        <Select labelId="choice-confirm" value={confirmDialog.choice} label={confirmDialog.choiceTitle} onChange={(e) => setConfirmDialog({ ...confirmDialog, choice: e.target.value })} >
                            {confirmDialog.choices?.map((v) => (<MenuItem value={v.value}>{v.text}</MenuItem>))}
                        </Select>
                    </FormControl>
                </Typography>
            </DialogContent>
            <DialogActions className={classes.dialogAction}>
                <Controls.ButtonColor
                    text="Cancel"
                    color="default"
                    onClick={!confirmDialog.onCancel ? () => setConfirmDialog({ ...confirmDialog, isOpen: false }) : () => confirmDialog.onCancel()} />
                <Controls.ButtonDanger
                    text="Continue"
                    color="default"
                    onClick={() => confirmDialog.onConfirm(confirmDialog.choice)} />
            </DialogActions>
        </Dialog>
    )
}
